.arsListingColumnPropertiesEditor {
  width: 100%;
  height: 100%;
  max-height: 200px;
  border: 1px solid var(--bs-success);
  border-radius: 4px;
}

.variableProperties {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
}
.variablePropertiesLabel {
  font-weight: bold;
  margin: 2px;
  padding: 2px;
}
.variablePropertiesTypeHolder {
  display: flex;
  align-items: center;
}
.variablePropertiesTypeSelect {
  margin-left: 0.5rem;
  margin: 2px;
  padding: 2px;
  outline: none;
  border: 1px solid var(--bs-gray-300);
  border-radius: 2px;
}
.variablePropertiesTypeSelect:focus {
  outline: 1px solid var(--bs-primary);
  box-shadow: none;
}
.variablePropertiesTypeOption {
  text-align: right;
}
.variablePropertiesDeleteButton {
  margin: 2px;
  padding: 2px;
  border: none;
  background-color: transparent;
  color: var(--bs-danger);
  cursor: pointer;
}

.columnVariablesHolder {
  position: relative;
  width: 100%;
}

.variableDropSortTarget {
  position: absolute;
  width: 100%;
  height: 16px;
  border-radius: 4px;
  z-index: 100;
}
.variableDropSortTargetActive {
  border-color: var(--bs-primary);
  background-color: var(--bs-primary);
  opacity: 0.2;
}
.cell {
  height: 100%;
  width: 100%;
}

.cell.disabled {
  font-style: italic;
  background-color: #d3d3d329;
}
